/// <reference path="../../common/common.module.ts" />
/// <reference path="webComponentRegistry.service.ts" />

/**
 * Web Component Loader Factory
 *
 * Generates bundle loader services from config instead of requiring
 * a hand-written service file per component.
 *
 * Convention:
 *   tag 'meevo-foo-bar' → path '/lib/meevo-foo-bar.js'
 *                        → service name 'fooBarWcLoader'
 *
 * Usage:
 *   // Option A: create a loader object directly
 *   var loader = webComponentLoaderFactory.create('meevo-your-feature');
 *   loader.load().then(function() { ... });
 *
 *   // Option B: create + register as named AngularJS service
 *   webComponentLoaderFactory.registerLoader('YourModule', 'meevo-your-feature');
 *   // Now $injector.get('yourFeatureWcLoader') works
 */
angular.module('meevo.components.common').factory('webComponentLoaderFactory', [
    '$q',
    function ($q: ng.IQService) {
        var loaderCache: { [tag: string]: ng.IPromise<void> | null } = {};

        function deriveScriptPath(tag: string): string {
            return '/lib/' + tag + '.js';
        }

        function deriveServiceName(tag: string): string {
            var withoutPrefix = tag.replace(/^meevo-/, '');
            var camel = withoutPrefix.replace(/-([a-z])/g, function (_m: string, c: string) {
                return c.toUpperCase();
            });
            return camel + 'WcLoader';
        }

        function createLoader(tag: string, scriptPath?: string): { load: () => ng.IPromise<void> } {
            var resolvedPath = scriptPath || deriveScriptPath(tag);

            return {
                load: function (): ng.IPromise<void> {
                    if (customElements.get(tag)) {
                        return $q.resolve();
                    }
                    if (loaderCache[tag]) {
                        return loaderCache[tag]!;
                    }

                    var deferred = $q.defer<void>();
                    loaderCache[tag] = deferred.promise;

                    var script = document.createElement('script');
                    script.src = resolvedPath + '?_=' + new Date().getTime();
                    script.onload = function () { deferred.resolve(); };
                    script.onerror = function () {
                        loaderCache[tag] = null;
                        // Remove the failed <script> node so it doesn't
                        // accumulate in <head> across retries.
                        if (script.parentNode) {
                            script.parentNode.removeChild(script);
                        }
                        deferred.reject('Failed to load ' + resolvedPath);
                    };
                    document.head.appendChild(script);

                    return loaderCache[tag]!;
                }
            };
        }

        return {
            create: createLoader,

            /**
             * Create a loader AND register it as a named AngularJS value
             * so $injector.get(serviceName) resolves it.
             */
            registerLoader: function (
                moduleName: string,
                tag: string,
                scriptPath?: string,
                serviceName?: string
            ): void {
                var name = serviceName || deriveServiceName(tag);
                var loader = createLoader(tag, scriptPath);
                try {
                    angular.module(moduleName).value(name, loader);
                } catch (e) {
                    console.warn('[webComponentLoaderFactory] Failed to register ' + name + ' on ' + moduleName, e);
                }
            },

            deriveServiceName: deriveServiceName,
            deriveScriptPath: deriveScriptPath,
        };
    }
]);
